module.exports = __webpack_public_path__ + "img/RunningDeadConceptArt3_1319x660.8a6dc191.png";